import React from 'react';
import PropTypes from 'prop-types';

import { bookingShape } from 'constants/propTypes';
import Payments from 'components/ui/Payments';
import { Page, Row } from 'components/shared/Layout';
import { hasHotel } from 'utils/booking';

const PaymentPending = ({
  booking: {
    reference,
    status,
    totalPriceToBePaid,
    payments,
    refunds,
    amountDue,
    customer,
    onHold,
    isPackage,
    hotels,
    outbound,
    inbound,
    passengers
  },
  currency,
  cancelPayments,
  refetchBooking
}) => (
  <Page>
    <Row span={16}>
      <Row start={2} span={14}>
        <Payments
          reference={reference}
          currency={currency}
          status={status}
          totalPriceToBePaid={totalPriceToBePaid}
          payments={payments}
          refunds={refunds}
          amountDue={amountDue}
          customer={customer}
          depositAmount={onHold.depositAmount}
          isPackage={isPackage}
          hasHotel={hasHotel({ hotels })}
          cancelPayments={cancelPayments}
          refetchBooking={refetchBooking}
          outbound={outbound}
          inbound={inbound}
          passengers={passengers}
        />
      </Row>
    </Row>
  </Page>
);

PaymentPending.propTypes = {
  booking: bookingShape,
  currency: PropTypes.string.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  paymentCurrencies: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  cancelPayments: PropTypes.func.isRequired,
  refetchBooking: PropTypes.func
};

export default PaymentPending;
